import { Row, Col, Card } from "reactstrap";
import { Progressbar } from "../../../../AbstractElements";
import { BasicProgressBars } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BASIC_PROGRESS_DATA, BASIC_PROGRESS_LIST } from "../../../../Data/UiKit/Progress/index";

export const BasicProgressBarsCart = () => {
  return (
    <Card>
      <CommonCardHeader title={BasicProgressBars} span={BASIC_PROGRESS_DATA} />
      <Row className="card-body progress-showcase">
        <Col>
          <Progressbar value="0" />
          {BASIC_PROGRESS_LIST.map(({ color, value,text }, index) => (
            <Progressbar color={color} value={value} key={index}>{text && text}</Progressbar>
          ))}
        </Col>
      </Row>
    </Card>
  );
};
